import { inject, Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FornitoriPort } from './fornitori.port';
import { Fornitore, CreateFornitoreDto, UpdateFornitoreDto } from '../../models/fornitori.model';
import {AttoriQueryParams, AttoriPagedResponse, CreateAttoreDto} from '../../models/attori.model';
import { environment } from '../../../environments/environment';
import {TenantService} from '../tenant.service';

@Injectable({ providedIn: 'root' })
export class FornitoriHttpService implements FornitoriPort {
  private http = inject(HttpClient);
  private tenantService = inject(TenantService);
  private base = `${environment.apiBaseUrl || ''}/${this.tenantService.tenant}/attori`;

  getList(): Observable<Fornitore[]> {
    const params = new HttpParams().set('isFornitore', 'true');
    return this.http.get<any>(this.base, { params }).pipe(
      map((res: any) => Array.isArray(res) ? res : (res?.content ?? []))
    );
  }

  getListPaginated(params: AttoriQueryParams): Observable<AttoriPagedResponse<Fornitore>> {
    let httpParams = new HttpParams()
      .set('isFornitore', 'true')
      .set('page', String(params.page ?? 0))
      .set('size', String(params.size ?? 20));
    if (params.wordSearch) httpParams = httpParams.set('wordSearch', params.wordSearch);
    if (params.sort) params.sort.forEach(s => { httpParams = httpParams.append('sort', s); });
    return this.http.get<any>(this.base, { params: httpParams }).pipe(
      map((res: any) => ({
        content: Array.isArray(res) ? res : (res?.content ?? []),
        totalElements: res?.totalElements ?? 0,
        totalPages: res?.totalPages ?? 0,
        pageIndex: res?.pageable?.pageNumber ?? params.page ?? 0,
      }))
    );
  }

  getById(id: number): Observable<Fornitore> {
    return this.http.get<Fornitore>(`${this.base}/${id}`);
  }

  create(dto: CreateFornitoreDto): Observable<Fornitore> {
    return this.http.post<Fornitore>(this.base, dto);
  }

  update(id: number, changes: UpdateFornitoreDto): Observable<Fornitore> {
    return this.http.patch<Fornitore>(`${this.base}/${id}`, changes);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  updateAttore(id: number, dto: Partial<CreateAttoreDto>): Observable<void> {
    return this.http.patch<void>(
      `${environment.apiBaseUrl || ''}/${this.tenantService.tenant}/attori/${id}`,
      dto
    );
  }
}
